import ActivityCorrectionStatusBadge from '@/components/activity/ActivityCorrectionStatusBadge';
import { SmartTableCellProps } from '@/components/ui/daisy';
import { ActivityProgress } from '@/models/ActivityProgress';

export default function ActivityStatusCell({
  item,
}: SmartTableCellProps<Pick<ActivityProgress, 'correctionStatus'>>) {
  return <ActivityCorrectionStatusBadge status={item.correctionStatus} />;
}
